// ══════════════════════════════════════════════
//  推荐位运营 - Mock 数据
//  TODO: 联调时替换为接口数据
// ══════════════════════════════════════════════

// 应用 / 推荐位（真实 getAppRecommendSlots，仅返回有推荐位的应用）
export const RECOMMEND_APPS = [
    {
        appId: 'app1', appName: 'HomeStar',
        slots: [
            { id: 's1', name: 'SD卡回放推荐位', code: 'SD_RP_BS_001' },
            { id: 's2', name: '首页推荐位', code: 'ALL_HOME_BS_003' },
        ],
    },
    {
        appId: 'app2', appName: 'SmartHome Pro',
        slots: [
            { id: 's3', name: '云回放推荐位', code: 'CS_RP_BS_002' },
        ],
    },
    { appId: 'app3', appName: 'CloudCam', slots: [] },
];

// 推荐位用户分群（真实 getUserSegmentList(2)）
export const RECOMMEND_USER_SEGMENTS = [
    { id: 'ug_rec_1', name: '高价值推荐用户' },
    { id: 'ug_rec_2', name: '活跃推荐用户' },
    { id: 'ug_rec_3', name: '沉默推荐用户' },
];

// 套餐（用于漏斗位选择）
// 价格单位：分，均只读来源《套餐配置》：
//   salePriceCny / noSubscriptionPriceCny —— 国内售价（CNY）
//   subscriptionRegionPricing / noSubscriptionRegionPricing —— 海外区域定价（海外默认 USD + 国家覆盖）
//   platformCostCny / platformCostUsd —— 套餐底价
export const RECOMMEND_PACKAGES = [
    { packageId: 'PKG2024003', name: '事件录像7天', categoryId: 1, releaseArea: ['1', '2'], releaseApps: ['APP_HOMESTAR', 'APP_SMARTHOME'], releaseOpsPosition: ['商城位', '推荐位'], isSubscription: 1, isNoSubscription: 0, salePriceCny: 690, salePriceUsd: 95, noSubscriptionPriceCny: null, noSubscriptionPriceUsd: null, subscriptionRegionPricing: { defaultUsd: 95, countryOverrides: [{ country: 'US', usdPrice: 120 }, { country: 'GB', usdPrice: 90 }] }, noSubscriptionRegionPricing: null, platformCostCny: 250, platformCostUsd: 35 },
    { packageId: 'PKG2024010', name: '国内专享-标清云存', categoryId: 1, releaseArea: ['1'], releaseApps: ['APP_HOMESTAR'], releaseOpsPosition: ['商城位'], isSubscription: 1, isNoSubscription: 1, salePriceCny: 9900, salePriceUsd: null, noSubscriptionPriceCny: 12900, noSubscriptionPriceUsd: null, subscriptionRegionPricing: null, noSubscriptionRegionPricing: null, platformCostCny: 1500, platformCostUsd: null },
    { packageId: 'PKG2024011', name: 'Overseas-Pro', categoryId: 1, releaseArea: ['2'], releaseApps: ['APP_HOMESTAR'], releaseOpsPosition: ['推荐位'], isSubscription: 1, isNoSubscription: 0, salePriceCny: null, salePriceUsd: 1299, noSubscriptionPriceCny: null, noSubscriptionPriceUsd: null, subscriptionRegionPricing: { defaultUsd: 1299, countryOverrides: [{ country: 'US', usdPrice: 1499 }] }, noSubscriptionRegionPricing: null, platformCostCny: null, platformCostUsd: 350 },
    { packageId: 'PKG2024020', name: 'AI智能检测月卡', categoryId: 2, releaseArea: ['1'], releaseApps: ['APP_SMARTHOME'], releaseOpsPosition: ['商城位'], isSubscription: 1, isNoSubscription: 0, salePriceCny: 1990, salePriceUsd: 299, noSubscriptionPriceCny: null, noSubscriptionPriceUsd: null, subscriptionRegionPricing: null, noSubscriptionRegionPricing: null, platformCostCny: 500, platformCostUsd: 80 },
    { packageId: 'PKG2024025', name: '全家桶年度套餐', categoryId: 4, releaseArea: ['1', '2'], releaseApps: ['APP_HOMESTAR'], releaseOpsPosition: ['推荐位'], isSubscription: 0, isNoSubscription: 1, salePriceCny: null, salePriceUsd: null, noSubscriptionPriceCny: 19900, noSubscriptionPriceUsd: 2999, subscriptionRegionPricing: null, noSubscriptionRegionPricing: { defaultUsd: 2999, countryOverrides: [{ country: 'JP', usdPrice: 3200 }] }, platformCostCny: 3000, platformCostUsd: 450 },
];

// 推荐位套餐漏斗（每个漏斗固定 4 个漏斗位）
export const RECOMMEND_FUNNELS = [
    {
        id: 1, slotCode: 'SD_RP_BS_001', name: 'SD回放基础漏斗', createdAt: 1742601600,
        funnelConfig: [
            { position: 1, packageId: 'PKG2024003', packageName: '事件录像7天', price: 6.90 },
            { position: 2, packageId: 'PKG2024010', packageName: '国内专享-标清云存', price: 99.00 },
            { position: 3, packageId: '', packageName: '' },
            { position: 4, packageId: '', packageName: '' },
        ],
    },
    {
        id: 2, slotCode: 'SD_RP_BS_001', name: 'SD回放升级漏斗', createdAt: 1742860800,
        funnelConfig: [
            { position: 1, packageId: 'PKG2024025', packageName: '全家桶年度套餐', price: 199.00 },
            { position: 2, packageId: '', packageName: '' },
            { position: 3, packageId: '', packageName: '' },
            { position: 4, packageId: '', packageName: '' },
        ],
    },
    {
        id: 3, slotCode: 'ALL_HOME_BS_003', name: '首页基础漏斗', createdAt: 1743033600,
        funnelConfig: [
            { position: 1, packageId: 'PKG2024020', packageName: 'AI智能检测月卡', price: 19.90 },
            { position: 2, packageId: 'PKG2024025', packageName: '全家桶年度套餐', price: 199.00 },
            { position: 3, packageId: '', packageName: '' },
            { position: 4, packageId: '', packageName: '' },
        ],
    },
    {
        id: 4, slotCode: 'CS_RP_BS_002', name: '云回放基础漏斗', createdAt: 1743206400,
        funnelConfig: [
            { position: 1, packageId: 'PKG2024011', packageName: 'Overseas-Pro', price: 12.99 },
            { position: 2, packageId: '', packageName: '' },
            { position: 3, packageId: '', packageName: '' },
            { position: 4, packageId: '', packageName: '' },
        ],
    },
];

// 推荐位策略
export const RECOMMEND_STRATEGIES = [
    {
        id: 1, slotCode: 'SD_RP_BS_001', name: '默认策略', isDefault: 1, createdAt: 1742601600,
        cooldownDays: null, popupInterval: 2, deliveryRegion: 3, userSegments: [], funnelRules: [],
        remark: '未命中分群的用户展示此策略',
    },
    {
        id: 2, slotCode: 'SD_RP_BS_001', name: 'SD回放推广策略', isDefault: 0, createdAt: 1742860800,
        cooldownDays: 3, popupInterval: 4, deliveryRegion: 1, userSegments: ['ug_rec_1', 'ug_rec_2'],
        funnelRules: [
            { condition: 1, funnelId: 1, templateIds: ['tpl_chunjie', 'tpl_gradient'] },
            { condition: 2, funnelId: 2, templateIds: [] },
        ],
        remark: 'SD回放场景主推',
    },
];

// 推荐位模板
const poster = (text, bg) => `data:image/svg+xml;utf8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="180" height="320"><rect width="100%" height="100%" fill="${bg}"/><text x="50%" y="52%" fill="#ffffff" font-size="18" font-family="sans-serif" text-anchor="middle" dominant-baseline="middle">${text}</text></svg>`)}`;

export const RECOMMEND_TEMPLATES = [
    { id: 1, code: 'tpl_chunjie', name: '春节红包', image: poster('春节红包', '#e6a23c') },
    { id: 2, code: 'tpl_gradient', name: '渐变科技', image: poster('渐变科技', '#409eff') },
    { id: 3, code: 'tpl_618', name: '618 大促', image: poster('618 大促', '#f56c6c') },
    { id: 4, code: 'tpl_minimal', name: '简约白', image: poster('简约白', '#67c23a') },
];
